import "core-js/modules/es6.number.constructor";
// client js begin
import util from '@tencent/vft-common/util';
// client js end
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: null
    },
    level: {
      type: Number,
      default: 0
    },
    hideMore: {
      type: Boolean,
      default: false
    },
    subPageInfo: {
      default: false
    },
    hideTitle: {
      default: false
    },
    isInSecondKill: {
      default: false
    },
    report: {
      type: Object,
      default: null
    }
  },
  computed: {
    isNotJump: function isNotJump() {
      return this.data.tModDescInfo.tJumpInfo.iTitleJumpType === 0;
    },
    isJumpSubPage: function isJumpSubPage() {
      return this.data.tModDescInfo.tJumpInfo.iTitleJumpType === 1;
    },
    isJumpUrl: function isJumpUrl() {
      return this.data.tModDescInfo.tJumpInfo.iTitleJumpType === 2;
    },
    jumpUrl: function jumpUrl() {
      return this.data.tModDescInfo.tJumpInfo.sUrl;
    }
  },
  methods: {
    toMore: function toMore() {
      if (this.subPageInfo) {
        var url = util.setUrlParam('subPageInfo', encodeURIComponent(JSON.stringify(this.subPageInfo)));
        this.openUrl(url);
      } else {
        if (this.isJumpSubPage) {
          var subPageInfo = {
            sChannelId: this.data.tModDescInfo.sChannelID,
            sModId: this.data.tModDescInfo.sModId
          };
          var _url = util.setUrlParam('subPageInfo', encodeURIComponent(JSON.stringify({
            vModIdList: [subPageInfo]
          })));
          this.openUrl(_url);
        } else {
          this.openUrl(this.jumpUrl);
        }
      }
    }
  }
};